import { Premium, PricingPlans } from '../../components/Pricing';
import PricingComparision from '../../components/Pricing/PricingComparison';

const Pricing = () => {
  return (
    <div>
      <PricingPlans />
      <PricingComparision />
      <Premium />
    </div>
  );
};

export default Pricing;
